export default __webpack_public_path__ + "static/media/hapPayLogo.065d0fd4.svg";